/**
 * MicroSiteHeaderSkeleton - Universal skeleton for Micro Site hero/header sections
 *
 * Matches the structure used across Terms, Classes, Contact: label, title, description.
 * Use on any Micro Site page that has this hero pattern.
 *
 * @example
 * ```tsx
 * <MicroSiteHeaderSkeleton />
 * ```
 */

"use client";

import { Box, Flex, Skeleton } from "@chakra-ui/react";

export const MicroSiteHeaderSkeleton = () => {
  return (
    <Box>
      <Skeleton
        height="14px"
        width="180px"
        mb={2}
        borderRadius="4px"
      />
      <Skeleton
        height={{ base: "32px", md: "40px" }}
        width={{ base: "140px", md: "180px" }}
        mb={3}
        borderRadius="4px"
      />
      <Flex direction="column" gap={2}>
        <Skeleton height="16px" width="100%" maxW="600px" borderRadius="4px" />
        <Skeleton height="16px" width="85%" maxW="500px" borderRadius="4px" />
      </Flex>
    </Box>
  );
};
